export class SetStatus {
  public static readonly type = '[Network] SetStatus';
  constructor(public readonly status: boolean | unknown) {}
}
